function getBonesForCoreEntrance(core, joint) {
	return joint.bones.filter((b) => core.data.level < b.floors);
}
export { getBonesForCoreEntrance };

//# sourceMappingURL=index183.js.map